import { Box, type BoxProps } from '@mui/material';

export type IBoxContainerProps = BoxProps;
export const BoxContainer = ({
  children,
  width,
  height,
  className,
  ...restBoxProps
}: BoxProps) => {
  return (
    <Box className={className} height={height} width={width} {...restBoxProps}>
      {children}
    </Box>
  );
};
